import { FC } from "react";

import Button from "@lhd/components/Button";
import useModalSelectIcon, { Props, ReceivedProps } from "./hook";
import { ModalWrapper } from "./styled";

const ModalSelectIconLayout: FC<Props> = ({
  isOpen,
  onCancel,
  onOk,
  imagePaths,
  currentSelectedImage,
  setCurrentSelectedImage,
}) => {
  return (
    <ModalWrapper
      width={768}
      open={isOpen}
      title="アイコン選択"
      onCancel={onCancel}
      footer={
        <>
          <Button label="保存" onClick={() => onOk(currentSelectedImage)} />
          <Button label="キャンセル" type="cancel-btn" onClick={onCancel} />
        </>
      }
    >
      <div className="wrap-list-icon-app">
        {imagePaths.map((pathItem, idx) => (
          <div
            key={`app-category-icon-${idx}`}
            className={`wrap-icon-app ${
              pathItem === currentSelectedImage ? "selected" : ""
            }`}
          >
            <img
              src={pathItem}
              alt=""
              onClick={() => setCurrentSelectedImage(pathItem)}
            />
          </div>
        ))}
      </div>
    </ModalWrapper>
  );
};

const ModalSelectIcon: FC<ReceivedProps> = (props) => (
  <ModalSelectIconLayout {...useModalSelectIcon(props)} />
);

export default ModalSelectIcon;
